import { AxiosResponse, AxiosInstance } from 'axios';

export interface RemoteControlHealthCheckRepository {
  (placeID: number): Promise<number>
}

const remoteControlHealthCheckRepository = (axios: AxiosInstance): RemoteControlHealthCheckRepository => async (placeID: number) => {
  const response: AxiosResponse = await axios.get(`/remote-control/health-check`, { params: { placeID } })
  return response.status
}

export default remoteControlHealthCheckRepository

